/**
 * This file is loaded by postcss-simple-vars
 * to provide global CSS variables.
 *
 * You must restart webpack in order for changes from this
 * file to be reflected. This should hot reload automatically,
 * but does not
 *
 * https://github.com/postcss/postcss-simple-vars
 *
 */

const EGYPTIAN_BlUE_LIGHT = '#D3D5DE';
const LIGHT_GRAY = '#F7F7F7';
const SPA_BLUE = '#EEEEF2';
const BYZANTIUM = '#7D2E68';
const EGYPTION_BLUE = '#003595';

module.exports = {

  // COLORS
  Byzantium: BYZANTIUM,
  Byzantium10P: BYZANTIUM+'1a', // 10%
  ByzantiumWhite: '#FCF8FB',
  Shadow: '#17130D',
  Charcoal: '#5A6268',
  CharcoalAAA: '#4B5257',
  EgyptianBlue: EGYPTION_BLUE,
  EgyptianLightBlue: EGYPTIAN_BlUE_LIGHT,
  CloudGray: '#F0F2F2',
  LightGray: LIGHT_GRAY,
  ArrowButtonBG: LIGHT_GRAY,
  ArrowButtonBGHover: EGYPTION_BLUE+'33',   // 20%
  GreenRYB: '#61A60E',
  SilverSand: '#C7D1D5',
  SpaBlue: SPA_BLUE,
  SpaBlue95P: SPA_BLUE+'f2',  // 95%
  SpaBlue90P: SPA_BLUE+'e6',  // 95%
  BodyBGLevel0: '#FFFFFF',
  BodyBGLevel1: SPA_BLUE,
  BodyBGLevel2: EGYPTIAN_BlUE_LIGHT,
  CTABlue: '#243294',
  ErrorAAA: '#800000',
  LiveAA: '#D11F1F',
  GreenAA: '#3F7300',
  Danger: '#804050',
  DangerBG: '#F5EEEF',

  // BREAK POINTS
  Tablet: '(width <= 900px)',
  Mobile: '(width <= 600px)',

}
